import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton';
import { useAssetStatus, useStartLessonProgress, useStartTrackProgress } from '../userProgressQueries';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getListingUrl } from '../../../utils/RoutingUtils';
import styled, { css, mediaQuery } from '../../../utils/Styling';
import Raven from 'raven-js';
const WideUIButton = styled(UIButton).attrs({
  'data-test-id': 'overview-enroll-button',
  use: 'primary'
}).withConfig({
  displayName: "EnrollButton__WideUIButton",
  componentId: "sc-1e83v6l-0"
})(["max-width:600px !important;width:100%;", ""], mediaQuery('notMobile', css(["max-width:200px !important;"])));

const usePlaylistId = () => {
  const match = useRouteMatch('/saved-items/playlists/:playlistId');
  const playlistId = match && match.params && Number(match.params.playlistId) || undefined;
  return playlistId;
};

export const EnrollTrackButton = ({
  language,
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id
  });
  const [startTrackProgress, {
    startTrackProgressLoading
  }] = useStartTrackProgress({
    trackId: id,
    language: language.toLowerCase(),
    playlistId
  });

  const handleEnroll = () => {
    startTrackProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'TRACK',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };

  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startTrackProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.track.${status}`
    })
  });
};
export const EnrollLessonButton = ({
  language,
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'LESSON',
    id
  });
  const [startLessonProgress, {
    startLessonProgressLoading
  }] = useStartLessonProgress({
    lessonId: id,
    language: language.toLowerCase(),
    playlistId
  });

  const handleEnroll = () => {
    startLessonProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'LESSON',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };

  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startLessonProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.lesson.${status}`
    })
  });
};